import React from "react";
import saveIcon from "../../images/icon_save.svg";
import "./saveBtn.scss";

const SaveBtn = ({ isLoading, onBtnClick }) => {
    return (
        <img
            src={saveIcon}
            alt="saveIcon"
            className={isLoading ? "save-btn save-btn__loding" : "save-btn"}
            onClick={onBtnClick}
        ></img>
    );
};

export default SaveBtn;
